import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import CheckboxGroup from '../../components/CheckboxGroup';
import FASiteDataHelper from "../../data/FallowARM/FASiteDataHelper";
import MapWrapper from '../../components/MapWrapper';
import pageStyles from '../SiteSelectionStep.module.scss';
import sharedStyles from "../sharedPageStyles.module.scss";
import LoadingComponent from '../../components/LoadingComponent';

class FASiteSelectionStep extends Component {
  constructor(props) {
    super(props);
    this.mapChild = React.createRef();
    this.state = {
      loadingState: 'loading',
      error: {},
      selectedTab: '',
      sitesByState: null,
      siteLatLongInfo: [],
    };
  }

  onTabChange = (event, value) => {
    this.setState({
      selectedTab: value,
    });
  };

  findLatLongObj = (siteName) => {
    const lcSiteName = siteName.toLowerCase().trim();
    const latLongObj = this.state.siteLatLongInfo.find(element => element.site.toLowerCase() === lcSiteName);
    return latLongObj;
  };

  onSiteSelection = (event, value) => {
    let locationName = event.target.value;
    const locationCoordinates = this.findLatLongObj(locationName);
    this.mapChild.current.setMapCenter(locationCoordinates.lat, locationCoordinates.lng);
    
    this.props.handleSiteSelection(locationCoordinates);
  }

  siteWasPassed = () => {
    let result = false;
    if (this.props.selectedSite !== undefined) {
      if (this.props.selectedSite !== '') {
        result = true;
      }
    }
    
    return result;
  }

  isChecked = (site) => {
    let result = false;
    if (this.props.selectedSite) {
      if (this.props.selectedSite.toLowerCase() === site.toLowerCase()) {
        result = true;
      }  
    }
    return result;
  }

  isDisabled = (site) => {
    // Is this the checked checkbox ?
    return !this.isChecked(site) &&
      // Are we in singleSelectOnly mode ?
      this.props.singleSelectOnly &&
      // Has an option been selected ?
      this.siteWasPassed();
  }

  handleMapIconClick = (event, value) => {
    let siteName = value.site;

    const locationCoordinates = this.findLatLongObj(siteName);

    // let us also change the active tab group, so the proper state is highlighted
    // when the map icon has been clicked
    this.onTabChange(null, value.state);

    this.props.handleSiteSelection(locationCoordinates);
  }

  componentDidMount() {
    var self = this;
    FASiteDataHelper.sitesFromAPI()
      .then(function(response) {
        var sites = response.data.sites;
        var sitesByState = FASiteDataHelper.sitesByState(sites);
        var siteLatLongInfo = FASiteDataHelper.siteLatLongInfo(sites);
        self.setState({
          sites: sites,
          sitesByState: sitesByState,
          siteLatLongInfo: siteLatLongInfo,
          loadingState: 'success',
          selectedTab: Object.keys(sitesByState)[0] // let's just use the first one in the list
        });
      })
      .catch(function(error) {
        self.setState({
          loadingState: 'error',
          error: error
        });
      });
  }

  render() {
    return (
      <Box className={sharedStyles.scenarioStepSection}>
        {this.state.loadingState === 'loading' &&
          <div>
            <LoadingComponent
              fullwidth={true}
              state='loading'
            />
          </div>
        }
        {this.state.loadingState === 'error' &&
          <div>
            <LoadingComponent
              fullwidth={true}
              state='error'
              error={this.state.error}
            />
          </div>
        }
        {this.state.loadingState === 'success' &&
          <div>
            <Typography variant="h6">
              Site Selection
            </Typography>
            <Typography variant="body1" gutterBottom>
              Select site to analyse.
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: "flex-start", flexWrap: "wrap", alignItems: "stretch" }}>
              <Box sx={{ flexGrow: 0 }}>
                {this.state.loadingState === 'success' &&
                  <Tabs
                    orientation="vertical"
                    value={this.state.selectedTab}
                    variant="scrollable"
                    onChange={this.onTabChange}
                    sx={{ borderRight: 1, borderColor: 'divider' }}
                  >
                    {Object.keys(this.state.sitesByState).map((state) => {
                      return (
                        <Tab value={state} key={state} label={state} />
                      )
                    })}
                  </Tabs>}
              </Box>
              <Box sx={{ flexGrow: 0, flex: 1 }}>
                {Object.keys(this.state.sitesByState).map((state) => {
                  return (
                    <div 
                      key={state} 
                      hidden={this.state.selectedTab !== state}
                      id={`vertical-tabpanel-${state}`}
                      className={pageStyles.siteSelectionSection}>
                      <Box overflow="auto" sx={{ flexGrow: 1, padding: "0.5em"}}>
                        <CheckboxGroup
                          options={this.state.sitesByState[state]}
                          horizontal={false}
                          isChecked={this.isChecked}
                          onChange={this.onSiteSelection}
                        />
                      </Box>
                    </div>
                  )
                })}
              </Box>
              <Box overflow="auto" sx={{ flexGrow: 2, padding: "0.5em"}} className={pageStyles.hiddenMobile}>
                <MapWrapper
                  ref={this.mapChild}
                  markerPoints={this.state.siteLatLongInfo}
                  handleIconClick={this.handleMapIconClick}
                  selectedSites={[this.props.selectedSite]}
                  center={this.state.mapCenter}
                />
              </Box>
            </Box>
            <Box sx={{ width: "100%", marginTop: "1em" }}>
              <Typography variant="body1">
                Site Selected: {this.props.selectedSite || 'None'}
              </Typography>
              {this.props.singleSelectOnly && (
                <Typography variant="caption">
                  Only one site can be selected.
                </Typography>
              )}
            </Box>
          </div>
        }
      </Box>
    )
  }
}

FASiteSelectionStep.propTypes = {
  handleSiteSelection: PropTypes.func,
  selectedSite: PropTypes.string,
  selectedSiteId: PropTypes.number,
  singleSelectOnly: PropTypes.bool,
};

export default FASiteSelectionStep;
